import type { Verdict } from '@/types/assetCheck'

interface VerdictBadgeProps {
  verdict: Verdict
}

const STYLES: Record<Verdict, { dot: string; text: string; bg: string }> = {
  Kaufen: { dot: 'bg-green-500', text: 'text-green-800', bg: 'bg-green-50 border-green-200' },
  Vorsicht: { dot: 'bg-amber-500', text: 'text-amber-800', bg: 'bg-amber-50 border-amber-200' },
  'Nicht kaufen': { dot: 'bg-red-500', text: 'text-red-800', bg: 'bg-red-50 border-red-200' },
}

export function VerdictBadge({ verdict }: VerdictBadgeProps) {
  const s = STYLES[verdict]
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm font-semibold ${s.bg} ${s.text}`}
      data-testid="verdict-badge"
      data-verdict={verdict}
    >
      <span className={`h-2 w-2 rounded-full ${s.dot}`} aria-hidden />
      {verdict}
    </span>
  )
}
